<template>
  <div>
    <v-row>
      <v-fade-transition>
        <v-card
          class="mx-3 px-3 white--text"
          style="background-color:transparent;font-size:25px"
          flat
        >
          <p style="line-height:45px">
            <span style="opacity:0.9;font-size:16px">My mission started in 05/2020</span>
            <br />
            <b>
              These amazing people have saved
              <div style="font-size:50px;" class="number-of-cups mr-1">125</div>single-use plastic cups
            </b>
            <br />
          </p>
        </v-card>
      </v-fade-transition>
    </v-row>
    <v-row>
      <v-fade-transition>
        <v-slide-group v-if="!selfiesLoaded" center-active>
          <v-slide-item v-for="selfie in 5" :key="selfie+'n'">
            <div style="position:relative;" class="pt-2">
              <v-card
                height="200"
                width="100"
                class="ml-5 mb-3 mt-4 primary"
                style="overflow:hidden; transform: scaleX(-1);animation: zoominoutselfie 0.6s;"
              >
                <v-progress-linear indeterminate color="secondary" height="200"></v-progress-linear>
              </v-card>
            </div>
          </v-slide-item>
        </v-slide-group>
        <!-- <v-slide-group v-else-if="shadow && selfiesLoaded && selfies.length == 0 && !setSelfie" center-active>

        </v-slide-group>-->
        <v-slide-group v-else center-active class="pl-1">
          <v-slide-item v-if="setSelfie">
            <div style="position:relative;" class="pt-2">
              <v-card
                height="200"
                width="100"
                class="ml-5 mb-3 mt-4 primary"
                style="overflow:hidden"
              >
                <v-progress-linear
                  v-show="loadingCamera"
                  indeterminate
                  color="secondary"
                  height="200"
                ></v-progress-linear>
                <div
                  v-show="setSelfie"
                  class="d-flex align-center justify-center"
                  style="width:100%;height:100%;position:absolute;z-index:3;margin-top:15px"
                >
                  <p class="count-down" v-if="!loadingCamera && countDown == 3">3</p>
                  <p class="count-down" v-if="!loadingCamera && countDown == 2">2</p>
                  <p class="count-down" v-if="!loadingCamera && countDown == 1">1</p>
                </div>

                <!-- v-show="!loadingCamera" -->
                <vue-web-cam
                  v-show="setSelfie"
                  class="webcam"
                  style="transform: scaleX(-1)"
                  ref="webcam"
                  :device-id="deviceId"
                  height="100%"
                  @started="onStarted"
                  @stopped="onStopped"
                  @error="onError"
                  @cameras="onCameras"
                  @camera-change="onCameraChange"
                />
              </v-card>
            </div>
          </v-slide-item>
          <v-slide-item v-if="selfies.length == 0 && !setSelfie">
            <div style="position:relative;" class="pt-2">
              <v-card
                height="200"
                width="100"
                class="ml-5 mb-3 mt-4 primary"
                style="background-size: contain;background-position: center center;animation: zoominoutselfie 0.6s;"
                :style="{ 'background-image': `url(${customer.logoUrl})` }"
              ></v-card>
            </div>
          </v-slide-item>
          <v-slide-item v-for="(selfie, index) in selfies" :key="index">
            <div style="position:relative;" class="pt-2">
              <v-btn
                fab
                small
                dark
                color="accent"
                style="position:absolute;z-index:1;right:-10px"
                v-if="selfie.userUid == user.id"
                @click="$store.dispatch('deleteItem', {selfie:selfie, customer:$route.params.customer, cup: $route.params.cup})"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-card
                color="primary"
                class="ml-5 mb-3 mt-4"
                height="200"
                width="100"
                style="background-size: cover;background-position: center center;transform: scaleX(-1);animation: zoominoutselfie 0.6s;"
                :style="{ 'background-image': `url(${selfie.imageUrl})` }"
              ></v-card>
            </div>
          </v-slide-item>
        </v-slide-group>
      </v-fade-transition>
    </v-row>
    <v-row justify="end" style="min-height:90px">
      <v-fade-transition>
        <v-btn
          large
          class="ma-5 ml-6 text-none"
          style="animation-name: appear;
  animation-duration: 1s;"
          dark
          rounded
          v-show="Object.keys(user).length != 0 && !setSelfie"
          outlined
          @click="onStart()"
        >
          Take a selfie
          <v-icon right>mdi-camera-outline</v-icon>
        </v-btn>
      </v-fade-transition>
      <v-fade-transition>
        <v-btn
          large
          class="ma-5 text-none"
          dark
          rounded
          v-if="setSelfie && devices[1]"
          outlined
          @click="switchCamera()"
        >
          Switch
          <v-icon right>mdi-camera-retake-outline</v-icon>
        </v-btn>
      </v-fade-transition>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { WebCam } from "vue-web-cam";

export default {
  name: "Background",
  components: {
    "vue-web-cam": WebCam
  },
  computed: {
    ...mapState(["shadow", "selfies", "user", "selfiesLoaded", "customer"]),
    device: function() {
      return this.devices.find(n => n.deviceId === this.deviceId);
    }
  },
  watch: {
    camera: function(id) {
      // console.log("camera ", id);
      this.deviceId = id;
    },
    devices: function() {
      // console.log("devices ", this.devices);
      const [first, ...tail] = this.devices;
      if (first) {
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
      }
    }
  },
  data() {
    return {
      countDown: 4,
      loadingCamera: false,
      setSelfie: false,
      camera: null,
      deviceId: null,
      devices: []
    };
  },
  methods: {
    onCapture() {
      let image = this.$refs.webcam.capture();
      this.onStop();
      this.$store.dispatch("createItem", {
        image: image,
        params: this.$route.params
      });
      this.setSelfie = false;
    },
    onStarted(stream) {
      this.loadingCamera = false;
      let self = this;
      setTimeout(function() {
        self.onCapture();
        self.countDown = "";
      }, 3000);
      setTimeout(function() {
        self.countDown = 1;
      }, 2000);
      setTimeout(function() {
        self.countDown = 2;
      }, 1000);
      this.countDown = 3;
    },
    onStopped(stream) {},
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.setSelfie = true;
      this.loadingCamera = true;
      if (this.$refs.webcam) this.$refs.webcam.start();
    },
    onError(error) {
      console.log(error);
    },
    onCameras(cameras) {
      this.devices = cameras;
      this.onStart();
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
    },
    switchCamera() {
      if (this.camera == this.devices[0].deviceId) {
        this.camera = this.devices[1].deviceId;
      } else {
        this.camera = this.devices[0].deviceId;
      }
    }
  }
};
</script>

<style>
@keyframes countDown {
  0% {
    transform: scale(3);
  }
  100% {
    transform: scale(1);
  }
}
.count-down {
  font-size: 50px;
  color: white;
  animation: countDown 2s;
}

@keyframes zoominoutselfie {
  0% {
    transform: scale(1) scaleX(-1);
  }
  50% {
    transform: scale(0.9) scaleX(-1);
  }
  100% {
    transform: scale(1) scaleX(-1);
  }
}
@keyframes appear {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.webcam {
  height: 200px;
  object-fit: cover;
}
.v-slide-group__wrapper {
  padding-right: 20px;
}
</style>
